// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__l-0Lg","buttons":"PendingPaymentAlert_buttons__3b6e4"};